import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";

type WorkspaceErrorBoundaryProps = {
  children: ReactNode;
};

type WorkspaceErrorBoundaryState = {
  failed: boolean;
};

export class WorkspaceErrorBoundary extends Component<
  WorkspaceErrorBoundaryProps,
  WorkspaceErrorBoundaryState
> {
  state: WorkspaceErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): WorkspaceErrorBoundaryState {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    if (import.meta.env.DEV) {
      console.error("Workspace rendering failed", error, info.componentStack);
    }
  }

  private retry = () => {
    this.setState({ failed: false });
  };

  render() {
    if (!this.state.failed) return this.props.children;

    return (
      <section className="workspace-error-state" role="alert">
        <span className="workspace-eyebrow">Workspace unavailable</span>
        <h1>We could not load this workspace</h1>
        <p>
          Your account and business data are safe. Check your connection and try
          again.
        </p>
        <button onClick={this.retry} type="button">
          Retry workspace
        </button>
      </section>
    );
  }
}
